import { db } from '../config/firebase';
import { collection, addDoc, updateDoc, deleteDoc, doc, getDoc, getDocs, query, orderBy } from 'firebase/firestore';
import { Facebook } from '../types/facebook';

const COLLECTION_NAME = '8am-facebook';

export class FacebookService {
    private facebook: Facebook[] = [];

    async addFacebookConfig(facebook: Facebook): Promise<Facebook> {
        try {
            const docRef = await addDoc(collection(db, COLLECTION_NAME), {
                ...facebook,
                createdAt: new Date(),
                updatedAt: new Date()
            });
            return { id: docRef.id, ...facebook };
        } catch (error) {
            throw new Error('Cannot add Facebook configuration: ' + error);
        }
    }

    async getAllFacebookConfigs(): Promise<Facebook[]> {
        try {
            const querySnapshot = await getDocs(
                query(
                    collection(db, COLLECTION_NAME),
                    orderBy('createdAt', 'desc')
                )
            );
            console.log(querySnapshot.docs);
            return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })) as Facebook[];
        } catch (error) {
            throw new Error('Cannot retrieve Facebook configurations: ' + error);
        }
    }

    async getFacebookConfigById(id: string): Promise<Facebook | null> {
        const docRef = doc(db, COLLECTION_NAME, id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return { id: docSnap.id, ...docSnap.data() } as Facebook;
        }
        return null;
    }

    async updateFacebookConfig(id: string, facebook: Partial<Facebook>): Promise<void> {
        try {
            const docRef = doc(db, COLLECTION_NAME, id);
            await updateDoc(docRef, {
                ...facebook,
                updatedAt: new Date()
            });
        } catch (error) {
            throw new Error('Cannot update Facebook configuration: ' + error);
        }
    }

    async deleteFacebookConfig(id: string): Promise<void> {
        try {
            const docRef = doc(db, COLLECTION_NAME, id);
            await deleteDoc(docRef);
        } catch (error) {
            throw new Error('Cannot delete Facebook configuration: ' + error);
        }
    }
} 